import React from 'react';

import BallotOutlinedIcon from '@material-ui/icons/BallotOutlined';
import DescriptionIcon from '@material-ui/icons/Description';

import i18n from '../../i18n';

const menuItems = [
  {
    name: i18n.t`Product`,
    icon: <BallotOutlinedIcon />,
    subItems: [
      {
        name: i18n.t`Manage suppliers`,
        path: '/admin/suppliers',
        icon: <DescriptionIcon fontSize="small" />,
      },
      {
        name: i18n.t`Manage products`,
        path: '/admin/products',
        icon: <DescriptionIcon fontSize="small" />,
      },
      {
        name: i18n.t`Sells`,
        path: '/admin/products/sells',
        icon: <DescriptionIcon fontSize="small" />,
      },
    ],
  },
];

export default menuItems;
